import { render } from "./ModalAddPromotionalTopUp.vue?vue&type=template&id=a04a7720&scoped=true"
import script from "./ModalAddPromotionalTopUp.vue?vue&type=script&lang=js"
export * from "./ModalAddPromotionalTopUp.vue?vue&type=script&lang=js"

import "./ModalAddPromotionalTopUp.vue?vue&type=style&index=0&id=a04a7720&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04a7720"]])

export default __exports__